<template>
      <div class="staffEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'staff', params: {} }">
          Staff
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider v-if="staff">/</v-breadcrumbs-divider>
          <v-breadcrumbs-item
            v-if="staff"
            :exact="true"
            :to="{ name: 'staffView', params: { id: staff.id } }"
          >
            {{ staff.firstName }} {{ staff.lastName }}
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'staffEdit', params:{id: id} }">
            Edit Staff
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Staff</v-card-title>
          <v-card-text>
            <staff-form v-model="staff" :id="id"></staff-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import StaffForm from './StaffForm.vue';

    export default {
      name: 'staff',
      data () {
        return {
          id: null,
          staff: null
        }
      },
      components: {
        StaffForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    